import { render, staticRenderFns } from "./TermosAcatamento.vue?vue&type=template&id=59039981"
import script from "./TermosAcatamento.vue?vue&type=script&lang=js"
export * from "./TermosAcatamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports